"use strict";

import { combineEpics } from "redux-observable";

import {
     dataUploadDataTemplateListEpic,
     dataUploadSilentListEpic,
     dataUploadListEpic,
     dataUploadAddEpic,
     dataUploadSummeryEpic,
     dataUploadDataProcessingRecodeEpic,
     dataUploadDownloadSummaryEpic,
     imageUploadEpic,
     dataFileTypeListEpic,
     dataFileSchemaListEpic,
     dataUploadRecordCountEpic,
     downloadSchemaTempEpic,
     downloadActiveRecordsEpic,
     downloadDeleteRecordsEpic
} from "./dataUpload.epics";

import {
     lookupTableListEpic,
     lookupTableTypesEpic,
     lookupTableAddEpic,
     lookupTableDeleteEpic,
     lookupTableGetEpic,
     lookupTableEditEpic,
     lookupTableActiveInactiveEpic,
     lookupTableValueListEpic,
     lookupTableValueAddEpic,
     lookupTableValueDeleteEpic,
     lookupTableValueGetEpic,
     lookupTableValueEditEpic,
     lookupLabelsTypesEpic,
     lookupTablesCSVFileUploadEpic,
     lookupTablesSingleCSVFileUploadEpic,
} from "./lookupTable.epics";

import {
     factTableListEpic,
     factTableTypesEpic,
     factTableAddEpic,
     factTableDeleteEpic,
     factTableGetEpic,
     factTableEditEpic,
     factTableActiveInactiveEpic,
     factTableValueListEpic,
     factTableValueAddEpic,
     factTableValueDeleteEpic,
     factTableSchemaValueGetEpic,
     factTableValueEditEpic,
     factTableGetAllSchemaTypeEpic,
     factTableGetAllSchemeAttributeEpic,
     factTablesSchemaValueReOrderEditEpic,
     factTablesSchemaTemplateEpic,
     factTablesGetValueEpic,
     factTablesCreateByCsvUploadEpic,
     factTablesGetJsonSchemaEpic,
     factTablesFactTableRecordEpic,
     factTablesDeleteJsonSchemaEpic,
     factTablesEditTableRecordEpic,
     factTablesGetTableRecordEpic,
     factLabelsTypesEpic,
} from "./factTable.epics";

import {
     loginAuthEpic,
     logoutAuthEpic,
     getNewActionTokenEpic,
     reRegistrationEpic,
     reRegistrationActivateEpic,
     sendOptEpic,
     reSendOptEpic,
     forgotPasswordEmailVeryficationEpic,
     forgotPasswordResetPasswordEpic,
     getUserDetailsEpic,
} from "./auth.epics";

import {
     // start of about campaign epics
     incentiveAddAboutCampaignEpic,
     // end of about campaigns epics
     incentiveListEpic,
     incentiveDeleteEpic,
     incentiveTypesEpic,
     participantListEpic,
     getCampaignProductEpic,
     getCampaignTemplateTypeEpic,
     getCampaignSalesEpic,
     getCampaignParticipantsEpic,
     campaignTypesEpic,
     incentiveSearchListEpic,
     incentiveChangeStatusEpic,
     creationStepOneEpic,
     incentiveHeaderContentAddEpic,
     incentiveHeaderContentUpdateEpic,
     incentiveHeaderContentGetListEpic,
     incentiveHeaderContentGetEpic,
     incentiveHeaderContentPublishEpic,
     getParticipantDataTemplateEpic,
     getSalseDataTemplateEpic,
     updateAboutCampaignStepOneEpic,
     getAboutCampaignStepOneEpic,
     listCampaignParticipantsEpic,
     addCampaignParticipantsEpic,
     incentiveQuickContentAddEpic,
     incentiveTermContentAddEpic,
     incentiveFaqContentAddEpic,
     listCampaignAdminsEpic,
     addCampaignAdminsEpic,
     incentiveAboutContentGetListEpic,
     incentiveQuickContentGetListEpic,
     incentiveTermContentGetListEpic,
     incentiveFaqContentGetListEpic,
     incentiveHeaderPublishedRevisionGetEpic,
     incentiveAboutPublishedRevisionGetEpic,
     incentiveQuickPublishedRevisionGetEpic,
     incentiveTermPublishedRevisionGetEpic,
     incentiveFaqPublishedRevisionGetEpic,
     incentiveAboutContentGetEpic,
     incentiveQuickContentGetEpic,
     incentiveTermContentGetEpic,
     incentiveAboutContentPublishEpic,
     incentiveQuickContentPublishEpic,
     incentiveTermContentPublishEpic,
     incentiveFaqContentPublishEpic,
     incentiveContentUnPublishEpic,
     incentiveFaqContentGetEpic,
} from "./incentive.epics";

import {
     dataTemplateTypeListEpic,
     addDataTemplateTypeEpic,
     dataTemplateCreateByCsvUploadEpic,
     dataTemplateGetAllSchemeAttributeEpic,
     dataTemplateGetAllTypesEpic,
     dataTemplateAddSchemaValuesEpic,
     dataTemplateSchemaValueGetEpic,
     dataTemplateListEpic,
     dataTemplateGetAllSchemaListEpic,
     dataTemplateValueDeleteEpic,
     dataTemplateSchemaValueReOrderEditEpic,
     dataTemplateGetValueEpic,
     dataTemplateGetJsonSchemaEpic,
     dataTemplateRecordEpic,
     dataTemplateEditTableRecordEpic,
     dataTemplateDeleteEpic,
     dataTemplateGetEpic,
     dataTemplateEditEpic,
     getDataTemplateLablesEpic,
     getDataTemplateTypesEpic,
     dataTemplateValueEditEpic,
     dataTemplateJsonSchemaDeleteEpic,
     dataTemplateGetTableRecordEpic,
     dataTemplateGetParticipantAccountListEpic,
     dataTemplateParticipantUserAccountCreateEpic,
} from "./dataTemplate.epic";
import {
     dashBoardGetCampaignPageViewSummaryEpic,
     dashBoardGetCommsPageViewSummaryEpic,
     dashBoardGetDashboardSummaryEpic,
     dashBoardGetParticipantActivationSummaryEpic,
     dashBoardGetParticipantLoginSummaryEpic,
     dashBoardGetRewardIssuedByCampaignEpic,
     getDevicedUsedSummaryEpic,
     getEmailTrackingSummaryEpic,
     getEmailDispatchSummaryEpic,
     getQ4OilMasterSummaryEpic,
     getQ4WearTearSummaryEpic,
     getAbuDhabiSummaryEpic,
     getAreaListEpic,
     dashboardGetAreaManagersLeaguesRankSummaryEpic,
     dashBoardGetNotificationEpic,
     dashBoardDeleteNotificationEpic,
     dashBoardGetRewardIssuedByDownloadEpic,
     dashBoardGetParticipantActivationSummaryDownloadEpic,
     dashBoardGetUserLoginSummaryDownloadEpic,
     dashBoardGetEmailTrackingSummaryDownloadEpic,
     dashBoardGetEmailDispatchSummaryDownloadEpic,
     dashBoardGetCommsPageViewDownloadEpic,
     dashBoardGetDevicedUsedSummaryDownloadEpic,
     dashBoardGetCampaignPageViewSummaryDownloadEpic,
     dashBoardGetParticipantsSliderCardDownloadEpic,
     dashBoardGetLocationSliderCardDownloadEpic,
     dashBoardGetMostActiveDetailChartDataEpic,
     getTLCAreaListEpic,
     dashBoardGetTLCParticipantActivationSummaryEpic
} from "./dashboard.epics";
import { participantActiveParticipantEpic, participantDeleteParticipantEpic, participantGetApplicationEpic, participantGetAreasEpic, participantGetDealersEpic, participantGetParticipantSummaryEpic, participantGetRolesEpic, participantSaveNewParticipantEpic, participantUpdateDealerEpic, participantUpdateJobRoleEpic, participantUpdateParticipantStatusEpic, participantGetTlcCustomersEpic, participantGetCampaignMeasurementEpic } from "./participant.epic";
import { retailSalesGetActivationReportEpic, retailSalesGetActivationReportExportEpic, retailSalesGetWinnersEpic, retailSalesGetWinnerFilterOptionsEpic, retailSalesGetWinnerVouchersEpic, retailSalesResendActivationEpic, retailSalesAddWinnersEpic, retailSalesUpdateWinnerEpic, retailSalesGetDealersEpic, retailSalesSaveDealersEpic, retailSalesDealerLookupEpic, retailSalesDealerListEpic, retailSalesGetJobTitlesEpic, retailSalesSaveJobTitlesEpic, retailSalesDeleteJobTitleEpic } from "./retailSales.epic";
import { cxGetWinnersEpic, cxGetWinnersExportEpic, cxGetWinnerFilterOptionsEpic, cxGetJobRolesEpic, cxAddWinnersEpic } from "./cxAlwaysInTouch.epic";
import {
     optimumFrictionPreviewTrainingImportEpic,
     optimumFrictionCommitTrainingImportEpic,
     optimumFrictionGetReportEpic,
     optimumFrictionGetTrainingImportsEpic,
} from "./optimumFriction.epic";
import { lcvParticipantsGetJobRolesEpic, lcvParticipantsImportEpic, lcvParticipantsGetImportHistoryEpic } from "./lcvParticipants.epic";
import { lcvPrizePotGetEpic, lcvPrizePotSetAvailabilityEpic, lcvPrizePotIncreaseQuantityEpic, lcvPrizePotAddBudgetEntryEpic, lcvPrizePotGetBudgetActivityEpic } from "./lcvPrizePot.epic";
import { lcvManualPrizeWinsGetEpic, lcvManualPrizeWinsSetFulfilmentEpic } from "./lcvManualPrizeWins.epic";
import { lcvCampaignsGetEpic } from "./lcvCampaign.epic";
import { lcvReportsGetDealersEpic, lcvReportsGetDealersExportEpic, lcvReportsGetGamesEpic, lcvReportsGetGamesExportEpic, lcvReportsGetFilterOptionsEpic } from "./lcvReports.epic";
import { lcvOrdersPreviewImportEpic, lcvOrdersImportEpic, lcvOrdersGetImportHistoryEpic } from "./lcvOrders.epic";

export default combineEpics(
     // start of about campaigns
     incentiveAddAboutCampaignEpic,
     incentiveAboutContentGetListEpic,
     incentiveAboutPublishedRevisionGetEpic,
     incentiveAboutContentGetEpic,
     incentiveAboutContentPublishEpic,
     //end of about campaigns

     //start of quick campaigns
     incentiveQuickContentAddEpic,
     incentiveQuickContentGetListEpic,
     incentiveQuickPublishedRevisionGetEpic,
     incentiveQuickContentGetEpic,
     incentiveQuickContentPublishEpic,
     // end of quick campaigns

     // start of term and condition
     incentiveTermContentAddEpic,
     incentiveTermPublishedRevisionGetEpic,
     incentiveTermContentGetEpic,
     incentiveTermContentPublishEpic,
     // end of term and condition

     // start of term and condition
     incentiveTermContentGetListEpic,
     // end of term and condition

     // start faq section
     incentiveFaqContentAddEpic,
     incentiveFaqContentGetListEpic,
     incentiveFaqPublishedRevisionGetEpic,
     incentiveFaqContentPublishEpic,
     // end of faq section

     incentiveContentUnPublishEpic,

     loginAuthEpic,
     logoutAuthEpic,
     getNewActionTokenEpic,
     reRegistrationEpic,
     reRegistrationActivateEpic,
     sendOptEpic,
     reSendOptEpic,
     forgotPasswordEmailVeryficationEpic,
     forgotPasswordResetPasswordEpic,
     getUserDetailsEpic,

     lookupTableListEpic,
     lookupTableTypesEpic,
     lookupLabelsTypesEpic,
     lookupTableAddEpic,
     lookupTableDeleteEpic,
     lookupTableGetEpic,
     lookupTableEditEpic,
     lookupTableActiveInactiveEpic,

     lookupTableValueListEpic,
     lookupTableValueAddEpic,
     lookupTableValueDeleteEpic,
     lookupTableValueGetEpic,
     lookupTableValueEditEpic,
     lookupTablesCSVFileUploadEpic,
     lookupTablesSingleCSVFileUploadEpic,

     factTableListEpic,
     factTableTypesEpic,
     factTableAddEpic,
     factTableDeleteEpic,
     factTableGetEpic,
     factTableEditEpic,
     factTableActiveInactiveEpic,
     factTableValueListEpic,
     factTableValueAddEpic,
     factTableValueDeleteEpic,
     factTableSchemaValueGetEpic,
     factTableValueEditEpic,
     factTablesCreateByCsvUploadEpic,
     factTablesGetJsonSchemaEpic,
     factTablesFactTableRecordEpic,
     dataUploadDataTemplateListEpic,
     dataUploadSilentListEpic,
     dataUploadListEpic,
     dataUploadAddEpic,
     dataUploadSummeryEpic,
     factTablesSchemaValueReOrderEditEpic,
     dataUploadDataProcessingRecodeEpic,
     dataUploadDownloadSummaryEpic,
     imageUploadEpic,
     factTablesDeleteJsonSchemaEpic,
     factTablesDeleteJsonSchemaEpic,
     factTablesEditTableRecordEpic,
     factTablesGetTableRecordEpic,
     factLabelsTypesEpic,

     incentiveListEpic,
     incentiveDeleteEpic,
     incentiveTypesEpic,
     participantListEpic,
     getCampaignProductEpic,
     getCampaignTemplateTypeEpic,
     getCampaignSalesEpic,
     getCampaignParticipantsEpic,
     campaignTypesEpic,
     incentiveSearchListEpic,
     incentiveChangeStatusEpic,
     creationStepOneEpic,
     incentiveHeaderContentAddEpic,
     incentiveHeaderContentUpdateEpic,
     incentiveHeaderContentGetListEpic,
     incentiveHeaderContentGetEpic,
     incentiveHeaderContentPublishEpic,
     incentiveHeaderPublishedRevisionGetEpic,
     getParticipantDataTemplateEpic,
     getSalseDataTemplateEpic,
     updateAboutCampaignStepOneEpic,
     getAboutCampaignStepOneEpic,
     listCampaignParticipantsEpic,
     addCampaignParticipantsEpic,
     listCampaignAdminsEpic,
     addCampaignAdminsEpic,

     factTableGetAllSchemaTypeEpic,
     factTableGetAllSchemeAttributeEpic,
     factTablesSchemaTemplateEpic,
     factTablesGetValueEpic,
     dataFileTypeListEpic,
     dataFileSchemaListEpic,

     dataTemplateTypeListEpic,
     addDataTemplateTypeEpic,
     dataTemplateCreateByCsvUploadEpic,
     dataTemplateGetAllSchemeAttributeEpic,
     dataTemplateGetAllTypesEpic,
     dataTemplateAddSchemaValuesEpic,
     dataTemplateSchemaValueGetEpic,
     dataTemplateListEpic,
     dataTemplateGetAllSchemaListEpic,
     dataTemplateValueDeleteEpic,
     dataTemplateSchemaValueReOrderEditEpic,
     dataTemplateGetValueEpic,
     dataTemplateGetJsonSchemaEpic,
     dataTemplateRecordEpic,
     dataTemplateEditTableRecordEpic,
     dataTemplateDeleteEpic,
     dataUploadRecordCountEpic,
     downloadSchemaTempEpic,
     downloadActiveRecordsEpic,
     downloadDeleteRecordsEpic,
     dataTemplateGetEpic,
     dataTemplateEditEpic,
     getDataTemplateLablesEpic,
     getDataTemplateTypesEpic,
     dataTemplateValueEditEpic,
     dataTemplateJsonSchemaDeleteEpic,
     dataTemplateGetTableRecordEpic,
     dataTemplateGetParticipantAccountListEpic,
     dataTemplateParticipantUserAccountCreateEpic,

     /**DashBoard Epic */
     dashBoardGetDashboardSummaryEpic,
     dashBoardGetParticipantActivationSummaryEpic,
     dashBoardGetRewardIssuedByCampaignEpic,
     dashBoardGetParticipantLoginSummaryEpic,
     dashBoardGetCampaignPageViewSummaryEpic,
     dashBoardGetCommsPageViewSummaryEpic,
     getDevicedUsedSummaryEpic,
     getEmailTrackingSummaryEpic,
     getEmailDispatchSummaryEpic,
     getQ4OilMasterSummaryEpic,
     getQ4WearTearSummaryEpic,
     getAbuDhabiSummaryEpic,
     getAreaListEpic,
     dashboardGetAreaManagersLeaguesRankSummaryEpic,
     dashBoardGetNotificationEpic,
     dashBoardDeleteNotificationEpic,
     dashBoardGetRewardIssuedByDownloadEpic,
     dashBoardGetParticipantActivationSummaryDownloadEpic,
     dashBoardGetUserLoginSummaryDownloadEpic,
     dashBoardGetEmailTrackingSummaryDownloadEpic,
     dashBoardGetEmailDispatchSummaryDownloadEpic,
     dashBoardGetCommsPageViewDownloadEpic,
     dashBoardGetDevicedUsedSummaryDownloadEpic,
     dashBoardGetCampaignPageViewSummaryDownloadEpic,
     dashBoardGetParticipantsSliderCardDownloadEpic,
     dashBoardGetLocationSliderCardDownloadEpic,
     dashBoardGetMostActiveDetailChartDataEpic,
     getTLCAreaListEpic,
     dashBoardGetTLCParticipantActivationSummaryEpic,
     incentiveFaqContentGetEpic,


     participantGetApplicationEpic,
     participantGetParticipantSummaryEpic,
     participantGetAreasEpic,
     participantGetDealersEpic,
     participantGetRolesEpic,
     participantSaveNewParticipantEpic,
     participantUpdateParticipantStatusEpic,
     participantDeleteParticipantEpic,
     participantActiveParticipantEpic,
     participantUpdateDealerEpic,
     participantUpdateJobRoleEpic,
     participantGetTlcCustomersEpic,
     participantGetCampaignMeasurementEpic,
     retailSalesGetWinnersEpic,
     retailSalesGetActivationReportEpic,
     retailSalesGetActivationReportExportEpic,
     retailSalesGetWinnerFilterOptionsEpic,
     retailSalesGetWinnerVouchersEpic,
     retailSalesResendActivationEpic,
     retailSalesAddWinnersEpic,
     retailSalesUpdateWinnerEpic,
     retailSalesGetDealersEpic,
     retailSalesSaveDealersEpic,
     retailSalesDealerLookupEpic,
     retailSalesDealerListEpic,
     retailSalesGetJobTitlesEpic,
     retailSalesSaveJobTitlesEpic,
     retailSalesDeleteJobTitleEpic,
     cxGetWinnersEpic,
     cxGetWinnersExportEpic,
     cxGetWinnerFilterOptionsEpic,
     cxGetJobRolesEpic,
     cxAddWinnersEpic,
     optimumFrictionPreviewTrainingImportEpic,
     optimumFrictionCommitTrainingImportEpic,
     optimumFrictionGetReportEpic,
     optimumFrictionGetTrainingImportsEpic,
     lcvParticipantsGetJobRolesEpic,
     lcvParticipantsImportEpic,
     lcvParticipantsGetImportHistoryEpic,
     lcvCampaignsGetEpic,
     lcvPrizePotGetEpic,
     lcvPrizePotSetAvailabilityEpic,
     lcvPrizePotIncreaseQuantityEpic,
     lcvPrizePotAddBudgetEntryEpic,
     lcvPrizePotGetBudgetActivityEpic,
     lcvManualPrizeWinsGetEpic,
     lcvManualPrizeWinsSetFulfilmentEpic,
     lcvReportsGetDealersEpic,
     lcvReportsGetDealersExportEpic,
     lcvReportsGetGamesEpic,
     lcvReportsGetGamesExportEpic,
     lcvReportsGetFilterOptionsEpic,
     lcvOrdersPreviewImportEpic,
     lcvOrdersImportEpic,
     lcvOrdersGetImportHistoryEpic
);
